<template>
  <el-card class="p-delete-account-confirmation__card">
    <div
      class="el-text--align-center pa-24"
    >
      <div class="el-text el-text--display-medium">
        {{ title }}
      </div>
      <div class="el-text el-text--body-24 ma-24">
        <span>{{ description }}</span>
      </div>
      <el-link
        v-if="deleteAccountConfirmationStatus === 'expired'"
        :href="accountUrl"
      >
        {{ $t('delete-account.delete-account-confirmation.go-to-account') }}
      </el-link>
      <el-link
        v-if="deleteAccountConfirmationStatus === 'error'"
        href="https://care.acronis.com/"
      >
        {{ $t('delete-account.delete-account-confirmation.contact-support') }}
      </el-link>
    </div>
  </el-card>
</template>

<script>
import { CustomerType } from '@/app/services/DeleteAccountService';
import { mapGetters } from 'vuex';

export default {
  name: 'DeleteAccountConfirmation',
  computed: {
    ...mapGetters('app', [
      'deleteAccountConfirmationStatus',
      'customerType'
    ]),
    title() {
      switch (this.deleteAccountConfirmationStatus) {
        case 'success':
          return this.$t('delete-account.delete-account-confirmation.success-title');
        case 'expired':
          return this.$t('delete-account.delete-account-confirmation.expired-title');
        case 'error':
          return this.$t('delete-account.delete-account-confirmation.error-title');
        default:
          return '';
      }
    },
    description() {
      switch (this.deleteAccountConfirmationStatus) {
        case 'success':
          return this.$t('delete-account.delete-account-confirmation.success-description');
        case 'expired':
          return this.$t('delete-account.delete-account-confirmation.expired-description');
        case 'error':
          return this.$t('delete-account.delete-account-confirmation.error-description');
        default:
          return '';
      }
    },
    accountUrl() {
      switch (this.customerType) {
        case CustomerType.atih:
          return '/ui/#/cti.a.ui.item.v1.0~a.ui.nav_menu.subitem.v1.0~a.ui.ext_p.cyber_protect.nav_menu.v1.0~a.ui.profile.v1.0';
        case CustomerType.acronis_backup:
          return '/ui/#/cti.a.ui.item.v1.0~a.ui.nav_menu.subitem.v1.0~a.ui.ext_p.cyber_protect.nav_menu.v1.0~a.ui.partner_profile.v1.0';
        default:
          return '';
      }
    }
  }
};
</script>
